import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../lightning-server-shared/com/lightningkite/UUID.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function URLs$JumpTo$Companion$$childSerializers$_anonymous__d708ch() {
  return createSimpleEnumSerializer('com.crowpay.JumpSection', values());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.b8s_1 = [lazy(tmp_0, URLs$JumpTo$Companion$$childSerializers$_anonymous__d708ch), null];
        this.c8s_1 = 'jumpto';
      }
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.URLs.JumpTo', this, 2);
        tmp0_serialDesc.a1b('section', false);
        tmp0_serialDesc.a1b('id', true);
        this.l8v_1 = tmp0_serialDesc;
      }
      m8v(encoder, value) {
        var tmp0_desc = this.l8v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance().b8s_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.n8v_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.o8v_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, DeferToContextualUuidSerializer_getInstance(), value.o8v_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m8v(encoder, value instanceof JumpTo() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l8v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance().b8s_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, DeferToContextualUuidSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, DeferToContextualUuidSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return JumpTo().p8v(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.l8v_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance().b8s_1[0].f2(), get_nullable(DeferToContextualUuidSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var JumpToClass;
function JumpTo() {
  if (JumpToClass === VOID) {
    class $ {
      toString() {
        return 'JumpTo(section=' + this.n8v_1.toString() + ', id=' + toString(this.o8v_1) + ')';
      }
      hashCode() {
        var result = this.n8v_1.hashCode();
        result = imul(result, 31) + (this.o8v_1 == null ? 0 : this.o8v_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof JumpTo()))
          return false;
        if (!this.n8v_1.equals(other.n8v_1))
          return false;
        if (!equals(this.o8v_1, other.o8v_1))
          return false;
        return true;
      }
      static p8v(seen0, section, id, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance().l8v_1);
        }
        var $this = createThis(this);
        $this.n8v_1 = section;
        if (0 === (seen0 & 2))
          $this.o8v_1 = null;
        else
          $this.o8v_1 = id;
        if ($this.n8v_1.s8v_1 && $this.o8v_1 == null)
          throw IllegalArgumentException().a1('JumpTo.' + $this.n8v_1.toString() + ' required an ID');
        return $this;
      }
    }
    initMetadataForClass($, 'JumpTo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    JumpToClass = $;
  }
  return JumpToClass;
}
var JumpSection_ProjectDetails_instance;
var JumpSection_ToDos_instance;
var JumpSection_ProjectMessages_instance;
var JumpSection_LineItemCompletionFlow_instance;
var JumpSection_IncidentFlow_instance;
var JumpSection_PendingChangeOrder_instance;
var JumpSection_ChangeItem_instance;
var JumpSection_LineItem_instance;
var JumpSection_ScopeView_instance;
var JumpSection_PayApp_instance;
var JumpSection_ContractorNote_instance;
var JumpSection_WorkTask_instance;
var JumpSection_PunchTask_instance;
var JumpSection_LineItemComment_instance;
var JumpSection_SettlementDocuments_instance;
var JumpSection_UnlockRequest_instance;
function values() {
  return [JumpSection_ProjectDetails_getInstance(), JumpSection_ToDos_getInstance(), JumpSection_ProjectMessages_getInstance(), JumpSection_LineItemCompletionFlow_getInstance(), JumpSection_IncidentFlow_getInstance(), JumpSection_PendingChangeOrder_getInstance(), JumpSection_ChangeItem_getInstance(), JumpSection_LineItem_getInstance(), JumpSection_ScopeView_getInstance(), JumpSection_PayApp_getInstance(), JumpSection_ContractorNote_getInstance(), JumpSection_WorkTask_getInstance(), JumpSection_PunchTask_getInstance(), JumpSection_LineItemComment_getInstance(), JumpSection_SettlementDocuments_getInstance(), JumpSection_UnlockRequest_getInstance()];
}
var JumpSection_entriesInitialized;
function JumpSection_initEntries() {
  if (JumpSection_entriesInitialized)
    return Unit_instance;
  JumpSection_entriesInitialized = true;
  JumpSection_ProjectDetails_instance = JumpSection().t8v('ProjectDetails', 0, false);
  JumpSection_ToDos_instance = JumpSection().t8v('ToDos', 1, false);
  JumpSection_ProjectMessages_instance = JumpSection().t8v('ProjectMessages', 2, false);
  JumpSection_LineItemCompletionFlow_instance = JumpSection().t8v('LineItemCompletionFlow', 3);
  JumpSection_IncidentFlow_instance = JumpSection().t8v('IncidentFlow', 4);
  JumpSection_PendingChangeOrder_instance = JumpSection().t8v('PendingChangeOrder', 5);
  JumpSection_ChangeItem_instance = JumpSection().t8v('ChangeItem', 6);
  JumpSection_LineItem_instance = JumpSection().t8v('LineItem', 7);
  JumpSection_ScopeView_instance = JumpSection().t8v('ScopeView', 8);
  JumpSection_PayApp_instance = JumpSection().t8v('PayApp', 9);
  JumpSection_ContractorNote_instance = JumpSection().t8v('ContractorNote', 10);
  JumpSection_WorkTask_instance = JumpSection().t8v('WorkTask', 11);
  JumpSection_PunchTask_instance = JumpSection().t8v('PunchTask', 12);
  JumpSection_LineItemComment_instance = JumpSection().t8v('LineItemComment', 13);
  JumpSection_SettlementDocuments_instance = JumpSection().t8v('SettlementDocuments', 14, false);
  JumpSection_UnlockRequest_instance = JumpSection().t8v('UnlockRequest', 15);
}
var JumpSectionClass;
function JumpSection() {
  if (JumpSectionClass === VOID) {
    class $ extends Enum() {
      static t8v(name, ordinal, requiresId) {
        requiresId = requiresId === VOID ? true : requiresId;
        var $this = this.c4(name, ordinal);
        $this.s8v_1 = requiresId;
        return $this;
      }
    }
    initMetadataForClass($, 'JumpSection');
    JumpSectionClass = $;
  }
  return JumpSectionClass;
}
function JumpSection_ProjectDetails_getInstance() {
  JumpSection_initEntries();
  return JumpSection_ProjectDetails_instance;
}
function JumpSection_ToDos_getInstance() {
  JumpSection_initEntries();
  return JumpSection_ToDos_instance;
}
function JumpSection_ProjectMessages_getInstance() {
  JumpSection_initEntries();
  return JumpSection_ProjectMessages_instance;
}
function JumpSection_LineItemCompletionFlow_getInstance() {
  JumpSection_initEntries();
  return JumpSection_LineItemCompletionFlow_instance;
}
function JumpSection_IncidentFlow_getInstance() {
  JumpSection_initEntries();
  return JumpSection_IncidentFlow_instance;
}
function JumpSection_PendingChangeOrder_getInstance() {
  JumpSection_initEntries();
  return JumpSection_PendingChangeOrder_instance;
}
function JumpSection_ChangeItem_getInstance() {
  JumpSection_initEntries();
  return JumpSection_ChangeItem_instance;
}
function JumpSection_LineItem_getInstance() {
  JumpSection_initEntries();
  return JumpSection_LineItem_instance;
}
function JumpSection_ScopeView_getInstance() {
  JumpSection_initEntries();
  return JumpSection_ScopeView_instance;
}
function JumpSection_PayApp_getInstance() {
  JumpSection_initEntries();
  return JumpSection_PayApp_instance;
}
function JumpSection_ContractorNote_getInstance() {
  JumpSection_initEntries();
  return JumpSection_ContractorNote_instance;
}
function JumpSection_WorkTask_getInstance() {
  JumpSection_initEntries();
  return JumpSection_WorkTask_instance;
}
function JumpSection_PunchTask_getInstance() {
  JumpSection_initEntries();
  return JumpSection_PunchTask_instance;
}
function JumpSection_LineItemComment_getInstance() {
  JumpSection_initEntries();
  return JumpSection_LineItemComment_instance;
}
function JumpSection_SettlementDocuments_getInstance() {
  JumpSection_initEntries();
  return JumpSection_SettlementDocuments_instance;
}
function JumpSection_UnlockRequest_getInstance() {
  JumpSection_initEntries();
  return JumpSection_UnlockRequest_instance;
}
//region block: exports
export {
  JumpTo as JumpTo1euh8ix4kcm68,
  Companion_getInstance as Companion_getInstance1xwqxy6002qfp,
};
//endregion

//# sourceMappingURL=URLs.mjs.map
